













import { Vue, Component, Prop } from 'vue-property-decorator';
import {IHub, initialHub} from '@/models/StoreModels.ts';


@Component({
  name: 'Markers',
  components: {
  },
})
export default class Markers extends Vue {
  @Prop({ default: () => initialHub })
  private hub !: IHub;

  @Prop({ default: false })
  private selected !: boolean;

  @Prop({ default: () => null })
  private markerClick!: (hub: IHub) => void;

  get hubCordinates(): {lat: number, lng: number} {
      return {
          lat: this.hub.geo_lat,
          lng: this.hub.geo_long,
      };
  }
}
